// extracted by mini-css-extract-plugin
module.exports = {"style":{"fontFamily":"'Montserrat', 'Montserrat Fallback'","fontStyle":"normal"},"className":"__className_da448f"};